<template>
  <div id="toast-wrapper" class="fixed z-50">
    <TheToast to="#toast-wrapper" />
  </div>

  <slot name="header">
    <ErrorOwners :owners="['bot-squad-search-and-recommendation-front']">
      <Transition enter-from-class="opacity-0" leave-to-class="opacity-0">
        <RevBackdrop
          v-if="isMenuActive || isSearchBarActive"
          class="z-10 hidden backdrop-blur-2xl transition-opacity duration-200 md:block"
        />
      </Transition>

      <div class="mood-inverse">
        <TheHeader />
      </div>

      <ClientOnly>
        <AddToCartPopover />
      </ClientOnly>
    </ErrorOwners>
  </slot>

  <slot />

  <slot name="footer">
    <ErrorOwners :owners="['bot-squad-search-and-recommendation-front']">
      <div class="mood-inverse">
        <Footer />
      </div>
    </ErrorOwners>
  </slot>
</template>

<script lang="ts" setup>
import { useHead } from '#imports'

import AddToCartPopover from '@backmarket/nuxt-layer-recommendation/AddToCartPopover.vue'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import ErrorOwners from '@backmarket/nuxt-module-logger/components/ErrorOwners.vue'
import TheToast from '@backmarket/nuxt-module-toast/TheToast.vue'
import { RevBackdrop } from '@ds/components/Backdrop'

import Footer from '~/scopes/footer/components/AppFooter.vue'
import TheHeader from '~/scopes/navigation/components/TheHeader/TheHeader.vue'
import { useActiveMenu } from '~/scopes/navigation/composables/useActiveMenu'
import { useToggleSearchBar } from '~/scopes/search-bar/composables/useToggleSearchBar'

const { isSearchBarActive } = useToggleSearchBar()
const { isMenuActive } = useActiveMenu()

useHead({
  htmlAttrs: {
    lang: useI18nLocale(),
  },
})
</script>
